<script setup lang="ts">
import { computed, inject } from "vue";

import { SearchContextWrapper } from "@tmi/types/context/search-context";
import { searchContextSymbol } from "@/constants";

import { getContentTypeDisplayTextFromKey } from "@/types/products/product-definitions";

import ContentElement from "@/components/content/ContentElement.vue";

// Provide the search context to all child components
const injectedContext = inject< SearchContextWrapper | undefined >( searchContextSymbol );
if ( !injectedContext ) {
  throw new Error( `The expected provided value for 'searchContextSymbol' does not exist in this context.` );
}

const {
  contentType,
  mostRecentlyViewedContentItems
} = injectedContext!;

const showRecentlyViewedItems = computed< boolean >( () => {
  let show = false;
  if ( mostRecentlyViewedContentItems ) {
    show = mostRecentlyViewedContentItems.value.length > 0
  }

  return show;
} );
</script>

<template>
  <div v-show="showRecentlyViewedItems" class=" ['wrapper'] recent-list">
    <h4 class="text-[#2c2c31] font-bold">{{ `Recently Viewed ${ getContentTypeDisplayTextFromKey( contentType ) }` }}</h4>
    <hr class="w-full h-px bg-[#D9D9D9]">
    <div class="space-y-5">
      <ContentElement v-for="content in mostRecentlyViewedContentItems" :key="content.contentfulId" :slug="content.slug"
                      :content-type="contentType!" class="content-wrapper" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.recent-list {
  padding: 20px 15px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 0 5px rgb(0 0 0 / 10%);
}

.wrapper {
  margin-bottom: 25px;
  width: 100%;

  .content-wrapper {
    display: flex;
    flex-direction: column;
  }
}
</style>
